export const OPEN_UPLOAD_PROGRESS = 'OPEN_UPLOAD_PROGRESS';
export const CLOSE_UPLOAD_PROGRESS = 'CLOSE_UPLOAD_PROGRESS';